import React from 'react';

import {ErrorFlatButton} from 'src/components/error-flat-button';
import {FormInput} from 'src/components/input';
import {CustomValidatedControl} from 'src/contexts/validation-context';

import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';


type Props = {
    id: number,
    totalCount: number,
    busy: boolean,
    accessDomain: string,
    onChange: (id: number, url: string) => void,
    onRemove: (id: number) => void,

    disabled?: boolean,
    readonly?: boolean,
};

export const DomainView = ({id, totalCount, accessDomain, busy, onChange, onRemove, disabled, readonly}: Props) => (
    <CustomValidatedControl name={`account-domain-${id}`}>
        {error => (
            <Group gap="xl" alignItems="start">
                <FormInput
                    maxLength={64}
                    readOnly={readonly}
                    disabled={disabled}
                    width={300}
                    value={accessDomain}
                    placeholder="Domain URL"
                    onBlur={domain => onChange(id, domain)}
                    busy={busy}
                    valid={error ? !error : undefined}
                    errorDescription={error}
                />
                {totalCount > 1 && !disabled && !readonly && (
                    <Item className="group-item pdy-xs">
                        <ErrorFlatButton
                            icon={Icons.TIMES_CIRCLE}
                            label="Remove"
                            onClick={() => onRemove(id)}
                        />
                    </Item>
                )}
            </Group>
        )}
    </CustomValidatedControl>
);
